import { TopToolbar, useTranslate } from 'react-admin'

import { Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

interface RelatedResourceToolbarProps {
    resource: string
    handleCreateCallback: () => void
}

const RelatedResourceToolbar = ({
    resource,
    handleCreateCallback
}: RelatedResourceToolbarProps) => {
    const translate = useTranslate()

    return (
        <TopToolbar>
            <Button color="primary" variant="outlined" onClick={handleCreateCallback}>
                <AddIcon />
                {translate(`manager.resources.${resource}.add`)}
            </Button>
        </TopToolbar>
    )
}

export default RelatedResourceToolbar
